import PropTypes from "prop-types";
import FilterOut from "../NotFound/FilterOut";
import ListingPage from "../ListingPage";
import ResultsHeader from "./ResultsHeader";
import ResultsFooter from "./ResultsFooter";
import styles from "./ProductList.css";
import config from "../../config/common";
import { withTranslation } from "../translation";
import withAdverts from "./withAdverts";
import ResultsSpinner from "./ResultsSpinner";

const {
  api: {
    product: {
      search: { pageSize }
    }
  }
} = config;

const renderProducts = ({
  offset: { initial },
  pages,
  tileToFocus: {
    first: focusFirstTile,
    last: focusLastTile,
    pageNumber: focusPageNumber
  },
  advert
}) => {
  const focusPageIndex = focusPageNumber - pages[0].pageNumber;

  return pages.map((page, index) => (
    <ListingPage
      focusFirstTile={index === focusPageIndex && focusFirstTile}
      focusLastTile={index === focusPageIndex && focusLastTile}
      isInitialPage={(page.pageNumber - 1) * pageSize === initial}
      page={page}
      key={page.pageNumber}
      advert={advert}
    />
  ));
};

const ResultsList = ({
  pages,
  offset,
  tileToFocus,
  itemCount,
  showLoadPrevious,
  showLoadMore,
  isLoading,
  listAdvert,
  footerAdvert
}) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <ResultsHeader
        showLoadPrevious={showLoadPrevious}
        itemCount={itemCount}
      />
      <div className={styles.productList} data-auto-id="productList">
        {isLoading && <ResultsSpinner />}
        {pages.length ? (
          renderProducts({ pages, tileToFocus, offset, advert: listAdvert })
        ) : (
          <FilterOut />
        )}
      </div>
      <ResultsFooter
        hasPages={!!pages.length}
        itemCount={itemCount}
        offset={offset}
        showLoadMore={showLoadMore}
      />
      {footerAdvert ? footerAdvert({ className: styles.advert }) : null}
    </div>
  </div>
);

ResultsList.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.object).isRequired,
  offset: PropTypes.object.isRequired,
  tileToFocus: PropTypes.shape({
    first: PropTypes.bool,
    last: PropTypes.bool,
    pageNumber: PropTypes.number
  }).isRequired,
  itemCount: PropTypes.number.isRequired,
  showLoadPrevious: PropTypes.bool.isRequired,
  showLoadMore: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  listAdvert: PropTypes.func,
  footerAdvert: PropTypes.func,
  formatTranslation: PropTypes.func.isRequired
};

export default withAdverts(withTranslation(ResultsList));
